import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
import { DEFAULT_LIMIT } from 'Src/consts/table';
import { Count } from 'Src/models/count';

export interface AwardItem {
  id: string;
  awardType: { id: string; name: string; picture?: string };
  awardedAt: string;
  awardedByName?: string;
  houseId?: string | null;
  houseName?: string | null;
  reason?: string;
  points: number;
  house?: { id: string; name: string | null; pic?: string | null } | null;
  school?: { id: string; pic?: string | null } | null;
  student?: {
    id: string;
    firstName: string;
    lastName: string;
    displayName: string;
  } | null;
}

export interface StudentAwardsOverview {
  items: AwardItem[];
  total: number;
  points: number;
  academicYear: string;
}

export function buildStudentAwardsFilter(
  page = 1,
  where: Record<string, any> = {},
  order?: string,
  limit = DEFAULT_LIMIT
) {
  const skip = Math.max(0, (page - 1) * limit);
  const filter: any = { limit, skip, where };
  if (order) filter.order = order;
  return filter;
}

export function getStudentAwardsCurrent(user: AppUser, filter?: any) {
  const { roleSessionKey: key } = user;
  const config = {
    headers: { usid: key },
    params: filter ? { filter } : undefined
  };
  return axios.get<AwardItem[]>(`${window.apiBase}/i/student/awards/current`, config).then(res => res.data);
}

export function getStudentAwardsCurrentCount(user: AppUser, where?: any): Promise<Count> {
  const { roleSessionKey: key } = user;
  const config = {
    headers: { usid: key },
    params: where ? { filter: { where: { ...where } } } : undefined
  };
  return axios.get<Count>(`${window.apiBase}/i/student/awards/current/count`, config).then(res => res.data);
}

export function getStudentAwardsCurrentOverview(user: AppUser, filter?: any): Promise<StudentAwardsOverview> {
  const { roleSessionKey: key } = user;
  const config = {
    headers: { usid: key },
    params: filter ? { filter } : undefined
  };
  return axios
    .get<StudentAwardsOverview>(`${window.apiBase}/i/student/awards/current/overview`, config)
    .then(res => res.data);
}
